import { createSelector } from 'reselect';
import { values } from 'lodash';
import { utils } from './../helpers';
import { jobScenariosActionTypes } from './../actions/types';
import { cachedRequestByIdReducer } from './helpers';

const jobScenarios = cachedRequestByIdReducer(jobScenariosActionTypes, 'byId');
export default jobScenarios;

const getJobScenariosState = state => state.jobScenarios;
export const jobScenariosByIds = state => getJobScenariosState(state).byId;
export const getJobScenariosById = (state, id) =>
  jobScenariosByIds(state)[id];


export const getJobScenarios = createSelector(
  getJobScenariosState,
  (jobScenariosState) => values(jobScenariosState.byId)
);


export const groupJobScenariosByScenarioId = createSelector(
  getJobScenarios,
  (jobScenarios) => utils.propertyAccumulatorReducer(jobScenarios, 'scenario_id')
);

export const getJobScenariosByScenarioId = (state, id) =>
  groupJobScenariosByScenarioId(state)[id];


// WEBPACK FOOTER //
// src/reducers/jobScenarios.js